<template>
  <section class="register-section">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-12 col-md-12 vector">
          <div class="col-xl-12 col-lg-8 col-md-12 shared">
            <h1 class="top-title">
              {{ $t("message.register.num") }}
              <span class="line">{{ $t("message.register.lines") }}</span>
            </h1>

            <div class="features">
              <div class="row">
                <div class="col-md-6 col-6">
                  <div class="shared-section">
                    <img
                      class="time-img"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/time.svg"
                      alt="Card image cap"
                    />

                    <span class="shared-title">
                      {{ $t("message.register.Time") }}</span
                    >
                  </div>
                </div>
                <div class="col-md-6 col-6">
                  <div class="shared-section">
                    <img
                      class="time-img"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/cup.svg"
                      alt="Card image cap"
                    />

                    <span class="shared-title">{{
                      $t("message.register.Reward")
                    }}</span>
                  </div>
                </div>

                <div class="col-md-6 col-6">
                  <div class="shared-section">
                    <img
                      class="time-img"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/color.svg"
                      alt="Card image cap"
                    />

                    <span class="shared-title">{{
                      $t("message.register.creative")
                    }}</span>
                  </div>
                </div>
                <div class="col-md-6 col-6 Different">
                  <div class="shared-section">
                    <img
                      class="time-img"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/calculater.svg"
                      alt="Card image cap"
                    />

                    <span class="shared-title">{{
                      $t("message.register.packges")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-12 register-card">
          <div class="col-xl-12 col-lg-9 col-md-12 parent">
            <h2 class="register-title">{{ $t("message.register.twoType") }}</h2>
            <p class="register-free">{{ $t("message.register.Free") }}</p>
            <div class="grid">
              <label class="card greeno-movement"
                ><input
                  class="card__input"
                  type="checkbox"
                  v-model="childRegister"
                />
                <div @click="childFlow()" id="greeno-body" class="card__body">
                  <div class="card__body-cover">
                    <img
                      v-if="windowWidth > 767"
                      id="greeno-hover"
                      class="card__body-cover-image greeno"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/greeno-ready.svg"
                    />
                    <img
                      v-if="windowWidth <= 767"
                      id="greeno-hover-mob"
                      class="card__body-cover-image greeno"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/greeno-ready.svg"
                    />
                    <span class="card__body-cover-checkbox">
                      <svg
                        class="card__body-cover-checkbox--svg"
                        viewBox="0 0 12 10"
                      >
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg
                    ></span>
                  </div>
                  <header class="card__body-header">
                    <h2 class="card__body-header-title">
                      {{ $t("message.register.who") }}
                    </h2>
                    <p class="card__body-header-subtitle">
                      {{ $t("message.register.Iwant") }}
                    </p>
                  </header>
                </div> </label
              ><label class="card redo-movement"
                ><input
                  class="card__input"
                  type="checkbox"
                  v-model="parentRegister"
                />
                <div @click="parentFlow()" id="redo-body" class="card__body">
                  <div class="card__body-cover">
                    <img
                      v-if="windowWidth > 767"
                      id="redo-hover"
                      class="card__body-cover-image redo"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/redo-ready.svg"
                      alt="redo"
                    />
                    <img
                      v-if="windowWidth <= 767"
                      id="redo-hover-mob"
                      class="card__body-cover-image redo"
                      src="https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/redo-ready.svg"
                      alt="redo"
                    />

                    <span
                      id="check-hover-redo"
                      class="card__body-cover-checkbox"
                    >
                      <svg
                        class="card__body-cover-checkbox--svg"
                        viewBox="0 0 12 10"
                      >
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg
                    ></span>
                  </div>
                  <header class="card__body-header">
                    <h2 class="card__body-header-title">
                      {{ $t("message.register.Who_is") }}
                    </h2>
                    <p class="card__body-header-subtitle">
                      {{ $t("message.register.Ineed") }}
                    </p>
                  </header>
                </div>
              </label>
            </div>
            <div class="col-12 register-btn">
              <button
                @click="createAcount()"
                v-if="childRegister || parentRegister"
                type="button"
                class="register"
              >
                {{ $t("message.register.register_btn") }}
              </button>
            </div>
            <div class="member">
              <div class="not_mem">
                <label for="signup"
                  >{{ $t("message.register.Ihaveaccount")
                  }}<span>
                    <router-link
                      class="sign_in"
                      :to="{
                        name: 'Login',
                        query: { lang: $route.query.lang },
                      }"
                      >{{ $t("message.register.SignIn") }}</router-link
                    >
                  </span></label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template> 

<script>
import $ from "jquery";
import router from "@/routes";
export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      childRegister: false,
      parentRegister: false,
    };
  },
  methods: {
    childFlow() {
      this.childRegister = true;
      this.parentRegister = false;
    },
    parentFlow() {
      this.parentRegister = true;
      this.childRegister = false;
    },
    createAcount() {
      if (this.parentRegister) {
        router.push({
          path: "/register/parent",
          query: { lang: this.$route.query.lang },
        });
      } else {
        router.push({
          path: "/register/child",
          query: { lang: this.$route.query.lang },
        });
      }
    },
  },
  mounted() {
    document.querySelector("html").classList.add("hide-footer");
    document.querySelector("html").classList.remove("show-footer");
    let vm = this;
    window.scrollTo(0, 0);
    $(window).on("popstate", function (event) {
      router.push({
        path: "/",
        query: { lang: vm.$route.query.lang },
      });
    });
    $("input.card__input").on("change", function () {
      $("input.card__input").not(this).prop("checked", false);
    });
    /////redo mouseover ////////
    $("#redo-body").mouseover(function () {
      $("#redo-hover").attr(
        "src",
        "../../../../static/img/hellocode-v2/redo-select.svg"
      );
      $("#redo-hover").css({
        width: "182px",
        height: "190.27px",
        left: "10px",
        right: "-15px",
      });
      $("#redo-hover-mob").attr(
        "src",
        "../../../../static/img/hellocode-v2/redo-select.svg"
      );
      $("#redo-hover-mob").css({
        width: "150px",
        height: "160px",
        left: "7px",
        right: "-15px",
      });
    });

    /////redo mouseout ////////
    $("#redo-body").mouseout(function () {
      $("#redo-hover").attr(
        "src",
        "../../../../static/img/hellocode-v2/redo-ready.svg"
      );
      $("#redo-hover").css({
        width: "196px",
        height: "201px",
        left: "0px",
        right: "-15px",
        bottom: "46px",
      });

      $("#redo-hover-mob").attr(
        "src",
        "../../../../static/img/hellocode-v2/redo-ready.svg"
      );
      $("#redo-hover-mob").css({
        width: "168px",
        height: "174px",
        left: "0px",
        right: "-15px",
      });
    });

    /////redo click ////////
    $("#redo-body").click(function () {
      $("#redo-hover").attr(
        "src",
        "../../../../static/img/hellocode-v2/redo-checked.svg"
      );
      $("#redo-hover").css({
        width: "196.72px",
        height: "158.69px",
        left: "-11px",
        bottom: "14px",
      });
      $("#redo-hover-mob").attr(
        "src",
        "../../../../static/img/hellocode-v2/redo-checked.svg"
      );
      $("#redo-hover-mob").css({
        width: "182.72px",
        height: "148.69px",
        left: "-4px",
      });
    });

    /////greeno mouseover ////////
    $("#greeno-body").mouseover(function () {
      $("#greeno-hover").attr(
        "src",
        "../../../../static/img/hellocode-v2/greeno-select.svg"
      );
      $("#greeno-hover").css({
        width: "162.73px",
        height: "184.66px",
        left: "40px",
      });
      $("#greeno-hover-mob").attr(
        "src",
        "../../../../static/img/hellocode-v2/greeno-select.svg"
      );
      $("#greeno-hover-mob").css({
        width: "152.73px",
        height: "174.66px",
        left: "30px",
      });
    });

    /////greeno mouseout ////////
    $("#greeno-body").mouseout(function () {
      $("#greeno-hover").attr(
        "src",
        "../../../../static/img/hellocode-v2/greeno-ready.svg"
      );
      $("#greeno-hover").css({
        width: "177px",
        height: "177px",
        left: "25px",
      });

      $("#greeno-hover-mob").attr(
        "src",
        "../../../../static/img/hellocode-v2/greeno-ready.svg"
      );
      $("#greeno-hover-mob").css({
        width: "125px",
        height: "163px",
        left: "30px",
      });
    });

    /////greeno click ////////
    $("#greeno-body").click(function () {
      $("#greeno-hover").attr(
        "src",
        "../../../../static/img/hellocode-v2/greeno-checked.svg"
      );
      $("#greeno-hover").css({
        width: "134.13px",
        height: "197.56px",
      });

      $("#greeno-hover-mob").attr(
        "src",
        "../../../../static/img/hellocode-v2/greeno-checked.svg"
      );
      $("#greeno-hover-mob").css({
        width: "103px",
        height: "156px",
      });
    });

    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    this.windowWidth = window.innerWidth;
  },
  components: {},
};
</script>

<style scoped>
.register-section {
  background-image: linear-gradient(270deg, #ffffff 50%, #fdfaf2 50%);
  min-height: 100vh;
  overflow: auto;
}
.vector {
  background-image: url(https://cdn-static-images-frontend.s3.eu-west-1.amazonaws.com/hellocodeV2/Mask.svg);
  background-position: 0px 370px;
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #fdfaf2;
}
.Different {
  padding-right: 0;
}
.register-card {
  background: #ffffff;
}
.parent {
  margin-left: initial;

  margin-top: 78px;
}
.register-btn {
  margin: 43px auto;
  display: flex;
  justify-content: center;
}
.register {
  background: #f4c045;
  box-shadow: inset 0px -4px 0px #cda804;
  border-radius: 14px;
  padding: 16px 32px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  border-color: transparent;
  cursor: pointer;
  text-align: center;
  color: #0b1e41;
}
.member {
  margin: 37px 0px 81px auto;
}

.top-title {
  padding-top: 121px;
  font-weight: bold;
  font-size: 59px;
  line-height: 88px;
  letter-spacing: -1.5px;
  color: #de6d91;
}
.register-title {
  font-weight: bold;
  font-size: 40px;
  line-height: 48px;
  text-align: center;
  letter-spacing: -1px;
  color: #101828;
}
.line {
  color: #254178;
}
.features {
  padding-top: 71px;
}
.time-img {
  width: 36px;
  height: 36px;
}
.shared-section {
  display: flex;
  align-items: center;
  margin: 16px 0px;
}
.shared-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #344054;
  margin: 0 10px;
}

.shared {
  padding: 0;
  margin-left: auto;
  margin-right: 16px;
}
.register-free {
  padding-top: 16px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #1d2939;
  text-align: center;
}
.sign_in {
  color: #3a6bcb;
}
@media (min-width: 999px) and (max-width: 1290px) {
  .shared {
    margin: auto;
  }
  .parent {
    margin-left: unset;
    margin-right: unset;
    margin: auto;
    margin-top: auto;
    top: 52px;
  }

  .top-title {
    text-align: center;
    padding-top: 120px;
  }
  .card {
    --card-height: 272px !important;
    --card-width: 207px !important;
    margin: -6px 16px !important;
  }
}
.card {
  --background: #fff;
  --background-checkbox: #f4bf44;
  --background-image: #fff rgba(0, 107, 175, 0.2);
  --text-color: #666;
  --text-headline: #000;
  --card-shadow: #f4bf44;
  --card-height: 272px;
  --card-width: 189px;
  --card-radius: 12px;
  --blend-mode: overlay;
  --transition: 0.15s;
  user-select: none;
  border: none;
  margin: 0px 16px;
  background: #ffffff;
  /* border: 2px solid #E4E7EC; */
  border-radius: 14px;
  position: relative;
}
.redo-movement {
  left: 11px;
}
.greeno-movement {
  left: 7px;
}
@media (min-width: 992px) and (max-width: 1286px) {
  .redo-movement {
    left: 11px;
  }

  .shared {
    padding: 0;
    margin: auto;
  }
  .top-title {
    text-align: center;
  }
  .greeno-movement {
    left: -15px;
  }
  .parent {
    margin-left: initial;
    margin-top: 78px;
    max-width: 100%;
  }
  .card {
    --card-width: 212px;
    --card-height: 282px;
    margin: 0 18px !important;
  }
}
.card__input {
  position: absolute;
  display: block;
  outline: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  -webkit-appearance: none;
}
.card__input:checked ~ .card__body {
  --shadow: 0 0 0 3px #f3c047;
}
.card__input:checked ~ .card__body .card__body-cover-checkbox {
  --check-bg: #f3c047;
  --check-border: #fff;
  --check-scale: 1;
  --check-opacity: 1;
}
.card__input:disabled ~ .card__body:active {
  --scale: 1;
}
.card__input:checked ~ .card__body .card__body-cover-checkbox--svg {
  --stroke-color: #fff;
  --stroke-dashoffset: 0;
}
.card__input:checked ~ .card__body .card__body-cover:after {
  --opacity-bg: 0;
}
.card__input:checked ~ .card__body .card__body-cover-image {
  --filter-bg: grayscale(0);
}

.card__body {
  display: grid;
  grid-auto-rows: calc(var(--card-height) - var(--header-height)) auto;
  background: var(--background);
  height: var(--card-height);
  width: var(--card-width);
  border-radius: var(--card-radius);
  position: relative;
  cursor: pointer;
  box-shadow: var(--shadow, 0 4px 4px 0 rgba(0, 0, 0, 0.02));
  transition: transform var(--transition), box-shadow var(--transition);
  transform: scale(var(--scale, 1)) translateZ(0);
  border: 2px solid #e4e7ec;
}
.card__body:active {
  --scale: 0.96;
}
.card__body-cover {
  --c-border: var(--card-radius) var(--card-radius) 0 0;
  --c-width: 100%;
  --c-height: 100%;
  position: relative;
}

.card__body-cover-image {
  width: var(--c-width);
  height: var(--c-height);
  object-fit: cover;
  border-radius: var(--c-border);
}
.card__body-cover:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: var(--c-width);
  height: var(--c-height);
  border-radius: var(--c-border);
  background: linear-gradient(to bottom right, var(--background-image));
  mix-blend-mode: var(--blend-mode);
  opacity: var(--opacity-bg, 1);
  transition: opacity var(--transition) linear;
}

.card__body-cover-checkbox {
  background: #f3c047;
  border: 2px solid var(--check-border, #fff);
  position: absolute;
  right: -15px;
  top: -15px;
  z-index: 1;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  opacity: var(--check-opacity, 0);
  transition: transform var(--transition),
    opacity calc(var(--transition) * 1.2) linear,
    -webkit-transform var(--transition) ease;
  transform: scale(var(--check-scale, 0));
}
.card__body-cover-checkbox--svg {
  width: 13px;
  height: 11px;
  display: inline-block;
  vertical-align: top;
  fill: none;
  margin: 7px 0 0 5px;
  stroke: var(--stroke-color, #fff);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 16px;
  stroke-dashoffset: var(--stroke-dashoffset, 16px);
  transition: stroke-dashoffset 0.4s ease var(--transition);
}
.greeno {
  width: 177px;
  height: 177px;
  position: relative;
  left: 8%;
  bottom: 16%;
}
.redo {
  width: 216px;
  height: 216px;
  position: relative;
  left: 0;
  bottom: 24%;
}
.card__body-header {
  height: var(--header-height);
  position: absolute;
  bottom: 0;

  padding: 0 8px 0px 10px;
}
.card__body-header-title {
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;

  color: #1d2939;
  margin-bottom: 8px;
}
.card__body-header-subtitle {
  font-weight: bold;
  line-height: 24px;

  color: #344054;
}

body .grid {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 768px) and (max-width: 998.9px) {
  .shared {
    margin: auto;
  }
  .card {
    --card-width: 213px;
  }
  .vector {
    background-image: url(../../../../static/img/hellocode-v2/Masktablet.svg);
    background-position: 616px -2px;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fdfaf2;
    order: 2;
  }
  .top-title {
    padding-top: 61px;
    text-align: center;
  }

  .parent {
    margin-top: 56px;
    max-width: 100%;
  }
  .features {
    margin: 50px;
  }

  .member {
    margin: 66px auto 25px;
  }
  .card__input:checked ~ .card__body {
    --shadow: 0 0 0 3px #f4bf44;
    width: 204px;
  }
  .card {
    --card-width: 212px;
    --card-height: 282px;
  }
}
@media (min-width: 320px) and (max-width: 767px) {
  .member {
    margin: -41px 0px 20px;
  }
  .vector {
    background-image: url(../../../../static/img/hellocode-v2/Masktablet.svg);
    background-position: 10px 2px;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fdfaf2;
  }
  .time-img {
    margin: auto;
  }
  .top-title {
    padding-top: 24px;
    text-align: center;
  }

  .card {
    margin: 50px 8px;
  }
  .card {
    --card-height: 268px;
    width: inherit;
  }
  .features {
    padding-top: inherit;
  }
  .shared-title {
    font-size: 12px;
  }
  .greeno {
    width: 134px;
    height: 162px;
    position: relative;
    left: 11%;
    bottom: 7%;
  }
  .redo {
    width: 165px;
    height: 173px;
    bottom: 12%;
  }
  .parent {
    margin-left: inherit;
    margin-right: inherit;
    margin-top: 40px;
  }
  .top-title {
    padding-top: 26px;
  }
  .line {
    font-size: 51px;
    line-height: 56px;
    text-align: center;
    letter-spacing: -1.5px;
    margin: 0px 3px;
  }
  .register-title {
    padding-top: 32px;
    font-size: 45px;
  }
  .register-free {
    padding-top: 13px;
    font-size: 18px;
  }
  .card__body {
    background: transparent;
  }
  .card__body-header-title {
    font-size: 22px;
  }
  .shared-section {
    display: grid;
    margin: auto;
    text-align: center;
  }
  .shared-title {
    margin: 10px 11px 28px 11px;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  .member {
    margin: -41px 0px 20px;
  }
  body .grid {
    margin-top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

@media (max-width: 320px) {
  .vector {
    background-image: url(../../../../static/img/hellocode-v2/Masktablet.svg);
    background-position: 10px 2px;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fdfaf2;
  }

  .row {
    margin-bottom: 30px;
  }
  .top-title {
    padding-top: 24px;
    text-align: center;
  }
  .shared-section {
    display: grid;
    margin: auto;
    text-align: center;
  }
  .time-img {
    margin: auto;
  }
  .shared-title {
    margin: 10px 11px 28px 11px;
  }
  body .grid {
    margin-top: 32px;
  }
  .card {
    margin: 50px 8px;
  }

  .card {
    --card-height: 268px;
    --card-width: 140px;
  }
  .greeno {
    width: 149px;
    height: 146px;
    top: 1%;
  }
  .redo {
    width: 146px !important;
    height: 136px !important;
    bottom: 0%;
    left: 11%;
  }
  .parent {
    margin-left: inherit;
    margin-right: inherit;
    margin-top: 40px;
  }
  .top-title {
    padding-top: 26px;
  }
  .line {
    font-size: 51px;
    line-height: 56px;
    text-align: center;
    letter-spacing: -1.5px;
    margin: 0px 3px;
  }
  .register-title {
    padding-top: 32px;
    font-size: 45px;
  }
  .register-free {
    padding-top: 13px;
    font-size: 16px;
  }
  .card__body {
    background: transparent;
  }

  .card__body-header-title {
    font-size: 16px;
  }
  .card__body-header-subtitle {
    font-size: 14px;
  }
}

@media (min-width: 50px) and (max-width: 319.88px) {
  .vector {
    background-image: url(../../../../static/img/hellocode-v2/Masktablet.svg);
    background-position: 10px 2px;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fdfaf2;
  }

  .row {
    margin-bottom: 30px;
  }
  .top-title {
    padding-top: 24px;
    text-align: center;
  }
  .shared-section {
    display: grid;
    margin: auto;
    text-align: center;
  }
  .time-img {
    margin: auto;
  }
  .shared-title {
    margin: 10px 11px 28px 11px;
  }
  body .grid {
    margin-top: 32px;
    display: grid;
  }
  .card {
    margin: 50px 8px;
  }
  .greeno {
    width: 149px;
    height: 146px;
    top: 1%;
  }
  .redo {
    width: 146px !important;
    height: 136px !important;
    bottom: 0%;
    left: 11%;
  }
  .parent {
    margin-left: inherit;
    margin-right: inherit;
    margin-top: 40px;
  }
  .top-title {
    padding-top: 26px;
  }
  .line {
    font-size: 51px;
    line-height: 56px;
    text-align: center;
    letter-spacing: -1.5px;
    margin: 0px 3px;
  }
  .register-title {
    padding-top: 32px;
    font-size: 45px;
  }
  .register-free {
    padding-top: 13px;
    font-size: 16px;
  }
  .card__body {
    background: transparent;
  }

  .card__body-header-title {
    font-size: 16px;
  }
  .card__body-header-subtitle {
    font-size: 14px;
  }
}
@media (min-width: 1201px) {
  .vector {
    background-image: none;
  }
}
@media (max-width: 1200px) {
  .container {
    max-width: 100%;
  }
  .register-section {
    background-image: none;
    background: #fdfaf2;
    height: 100vh;
  }
  .vector {
    background-position: initial;
    order: 2;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/main/register/register.vue